import styled from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from 'theme/theme';

export const PageHeaderFooterContainer = styled.div`
  width: calc(100% + ${gutterWidth}px);
  margin-left: ${-gutterWidth / 2}px;
  margin-top: ${gutterWidth}px;
  border-bottom: 6px solid ${colors.brandBlue};
`;

export const PageHeaderCartPillContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
